import React from "react";
import { ModalV2, Text, Flex, Button, Link } from "@jsq/ds/core";
import { formatShortFormDate } from "~/utils/datetime";
import { ProfileField } from "../../../ProfileField";
import { SearchInput } from "../../../types";
import { addressValue } from "../../ScreeningProfileView/styles_vanilla.css";
import { getProfileInfo, parseAddressFromLexisNexisMatch } from "../utils";
import { asOfDateText, headerClassName } from "./styles_vanilla.css";

export type ProfileDetailsModalProps = {
  show: boolean;
  onClose: () => void;
  searchInput: SearchInput | null;
  date: string | null;
};

const ProfileDetailsModal = ({
  show,
  onClose,
  searchInput,
  date,
}: ProfileDetailsModalProps) => {
  const isIndividual = searchInput?.EntityType === "Individual";
  const legalName = searchInput?.Name?.Full;
  const dob = getProfileInfo(searchInput?.AdditionalInfo, "Type", "DOB")?.Date?.Unparsed;
  const formattedDob = dob && formatShortFormDate(dob);
  const address = parseAddressFromLexisNexisMatch(searchInput?.Addresses, "ScreeningInput");

  const asOfDate = formatShortFormDate(date);

  return (
    <ModalV2
      show={show}
      onHide={onClose}
      size="small"
      title="Profile details"
      data-testid="profile-details-modal"
      headerClassName={headerClassName}
    >
      <ModalV2.Body>
        <Text variant="regular-md" className={asOfDateText}>
          As of {asOfDate}
        </Text>
        <Flex flexDirection="column" gap={20}>
          <ProfileField
            label="Profile"
            value={
              <Link to="" icon="external-link" iconPosition="right">
                {legalName}
              </Link>
            }
          />

          <ProfileField label="Legal name" value={legalName} />
          {isIndividual && formattedDob && (
            <ProfileField label={"Date of birth"} value={formattedDob} />
          )}
          <ProfileField
            label="Address"
            value={<Text className={addressValue}>{address}</Text>}
          />
        </Flex>
      </ModalV2.Body>

      <ModalV2.Footer>
        <Flex justifyContent="flex-end">
          <Button variant="primary" onClick={onClose} data-testid="close-button">
            Close
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};

export default ProfileDetailsModal;
